import React, { forwardRef, useRef } from 'react';
import { propsToDom } from 'core/helpers/propsToDom';
import styled from 'styled-components';
import { rem } from 'styles/utils';
// import { useInView } from 'react-intersection-observer';
import media from 'styles/media';
import useIntersectionObserver from 'hooks/useIntersectionObserver';

const PanelComponent = forwardRef(
  ({ id, nextId, background = 'dark', hasInViewAttr = false, children, ...others }, $outerRef) => {
    const $innerRef = useRef(null);
    const $ref = $outerRef || $innerRef;
    const isIntersecting = useIntersectionObserver($ref, {
      rootMargin: '-48% 0px -48% 0px',
      threshold: 0.0,
      once: true,
    });

    return (
      <div
        ref={$ref}
        data-id={id}
        data-next-id={nextId}
        data-background={background}
        data-in-view={isIntersecting}
        {...propsToDom(others)}
      >
        {children}
      </div>
    );
  }
);

PanelComponent.displayName = 'PanelComponent';

export const Panel = styled(PanelComponent)`
  --panel-padding: ${rem(140)};

  padding-top: var(--panel-padding);
  padding-bottom: var(--panel-padding);

  &[data-background='dark'] {
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }

  &[data-background='accent'] {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.black};
  }

  &[data-background='beige'] {
    background: ${({ theme }) => theme.colors.beige};
    color: ${({ theme }) => theme.colors.black};
  }

  &:first-child {
    padding-top: calc(var(--panel-padding) * 2 + var(--header-height, 0px));
  }

  &:last-child {
    padding-bottom: calc(var(--panel-padding) * 2);
  }

  &[data-id='hero'],
  &[data-id='relateds'] {
    --panel-padding: 0;
  }

  [data-id='hero'] {
    padding-top: calc(var(--panel-padding) * 2);
  }

  [data-id='hero'] + &[data-id='credits'] {
    padding-top: 0;
  }

  &[data-next-id='relateds'] {
    padding-bottom: calc(var(--panel-padding) * 2);
  }

  ${media.mobile`
    --panel-padding: ${rem(80)};

    &[data-id='hero'] {
      --panel-padding: 0;
    }
  `}
`;
